import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconBookmarkFullComponent } from "./med-icon-bookmark-full.component";

@NgModule({
  declarations: [
    MedIconBookmarkFullComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconBookmarkFullComponent,
  ],
})
export class MedIconBookmarkFullModule { }
